import apolloClient from 'src/config/apolloClient';
import { INSURANCE_QUERY } from './FETCH_IS_GOVERNMENT_INSURANCE.gql';

export default async function fetchIsGovernmentInsurance(
    insurancePlanId,
    allowGovernmentInsurance
) {
    const planId = parseInt(insurancePlanId, 10);
    if (planId < 0 || isNaN(planId)) {
        return false;
    }

    const insuranceQueryOptions = {
        variables: {
            planId: `ip_${insurancePlanId}`,
        },
        query: INSURANCE_QUERY,
    };

    try {
        const res = await apolloClient.query(insuranceQueryOptions);
        return allowGovernmentInsurance
            ? !res.data.insurancePlan.isPremiumEligibleInsurance
            : !res.data.insurancePlan.isNonGovernment;
    } catch (error) {
        return false;
    }
}
